export default {"src":"/_next/static/media/ijshockey.c70203e0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};